import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { createTitle } from '../utils/utils';
import { setActiveModule } from '../redux/reducers/layoutSlice';
import AdminHubLayout from '../components/admin/AdminHubLayout';
import { AddUserIcon, Edit05Icon } from '../utils/iconSvg';

const SCHOOL_SECTIONS = [
  {
    title: 'School management',
    subtitle: 'Add schools or browse the full directory',
    columns: 2,
    items: [
      {
        menu_name: 'Add School',
        title: 'Add School',
        description:
          'Register a school with state, district, area, and school name.',
        path: '/schools/add-school',
        accent: '#10B981',
        Icon: AddUserIcon
      },
      {
        menu_name: 'Schools',
        title: 'School list',
        description: 'View, search, activate, and manage all schools.',
        path: '/schools',
        accent: '#3B82F6',
        Icon: Edit05Icon
      }
    ]
  }
];

function SchoolHub() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = createTitle('School');
    dispatch(setActiveModule('School'));
  }, [dispatch]);

  const handleNavigation = (menuName, path) => {
    dispatch(setActiveModule(menuName));
    navigate(path);
  };

  return (
    <AdminHubLayout
      title="School"
      subtitle="Add a new school or view and manage the school list."
      sections={SCHOOL_SECTIONS}
      onNavigate={handleNavigation}
    />
  );
}

export default SchoolHub;
